import React from 'react';
import { useNavigate } from 'react-router-dom';
import { TERMS_VERSION, LEGAL_EFFECTIVE_DATE, PRIVACY_EMAIL } from '../../lib/legal';
import './Legal.css';

function TermsOfService() {
  const navigate = useNavigate();
  return (
    <div className="legal-page">
      <header className="legal-header">
        <button className="legal-back" onClick={() => navigate(-1)} aria-label="Indietro">←</button>
        <h1>Termini di utilizzo</h1>
      </header>
      <div className="legal-body">
        <p className="legal-meta">Versione {TERMS_VERSION} · In vigore dal {LEGAL_EFFECTIVE_DATE}</p>

        <h2>1. Titolare e accettazione</h2>
        <p>
          Il servizio Uptra è offerto da Simone Moreno (persona fisica), Corso Dante 117, interno 3, 16043 Chiavari (GE),
          Italia — C.F. MRNSNN98D11D969K, P.IVA 02715000994. La registrazione e l'uso del servizio implicano l'accettazione
          dei presenti Termini e la presa visione dell'Informativa Privacy.
        </p>

        <h2>2. Il servizio</h2>
        <p>Uptra è un'applicazione per il fitness: creazione di schede, tracciamento delle sedute, progressi, community e Modalità Coach per creare e assegnare programmi.</p>

        <h2>3. Account</h2>
        <p>L'utente dichiara di avere almeno 14 anni e di fornire dati veritieri; è responsabile della custodia delle proprie credenziali.</p>

        <h2>4. Condotta</h2>
        <p>È vietato l'uso illecito o abusivo del servizio e la pubblicazione di contenuti inappropriati nella community.</p>

        <h2>5. Modalità Coach</h2>
        <p>Il coach è unico responsabile dei contenuti, programmi e schede che crea e assegna. Uptra non verifica né garantisce l'idoneità dei programmi creati da coach terzi.</p>

        <h2>6. Salute e attività fisica</h2>
        <p>Uptra non fornisce consulenza medica. I contenuti non sostituiscono il parere di un medico o professionista. L'utente si allena sotto la propria responsabilità; si raccomanda di consultare un medico prima di iniziare un programma. È esclusa la responsabilità per eventuali infortuni, nei limiti di legge.</p>

        <h2>7. Proprietà intellettuale</h2>
        <p>Software e contenuti Uptra restano di titolarità del Titolare; i contenuti generati dagli utenti restano di questi ultimi.</p>

        <h2>8. Cancellazione dell'account</h2>
        <p>L'utente può eliminare il proprio account in autonomia. La cancellazione è definitiva e irreversibile; eventuali copie nei backup tecnici possono persistere fino alla loro scadenza. Le schede già assegnate agli atleti restano disponibili agli atleti anche dopo la cancellazione del coach che le ha create (il coach viene rimosso come autore).</p>

        <h2>9. Limitazione di responsabilità</h2>
        <p>Il servizio è fornito "così com'è", nei limiti consentiti dalla legge.</p>

        <h2>10. Foro competente</h2>
        <p>Foro competente: Genova, nei limiti consentiti dalla normativa applicabile.</p>

        <h2>11. Modifiche</h2>
        <p>I presenti Termini sono versionati; le modifiche saranno comunicate.</p>

        <h2>12. Contatti</h2>
        <p>{PRIVACY_EMAIL}</p>
      </div>
    </div>
  );
}

export default TermsOfService;
